(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    root.VariantContext = api;
    api.init(root.document, root);
  }
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  var CARD_SELECTOR = '[data-variant-context-card]';
  var LINK_SELECTOR = '[data-variant-context-link]';
  var SELECT_SELECTOR = '[data-variant-context-select]';
  var PRESENTATION_SELECTOR = '[data-variant-presentation]';

  function validVariantId(value) {
    return /^\d+$/.test(String(value || ''));
  }

  function variantUrl(href, variantId, baseHref) {
    if (!href || !validVariantId(variantId)) return href;

    var absoluteInput = /^[a-z][a-z\d+.-]*:/i.test(href) || href.indexOf('//') === 0;
    var url = new URL(href, baseHref || 'https://variant-context.invalid/');
    url.searchParams.set('variant', String(variantId));

    return absoluteInput ? url.href : url.pathname + url.search + url.hash;
  }

  function updateCardLinks(select, baseHref) {
    if (!select || !validVariantId(select.value) || !select.closest) return;

    var card = select.closest(CARD_SELECTOR);
    if (!card || !card.querySelectorAll) return;

    Array.prototype.forEach.call(card.querySelectorAll(LINK_SELECTOR), function (link) {
      var currentHref = link.getAttribute('href');
      link.setAttribute('href', variantUrl(currentHref, select.value, baseHref));
    });
  }

  function formatWeight(grams, locale) {
    var numericGrams = Number(grams);
    if (!Number.isFinite(numericGrams) || numericGrams <= 0) return '';

    if (numericGrams >= 1000) {
      return new Intl.NumberFormat(locale || 'es-MX', { maximumFractionDigits: 3 }).format(numericGrams / 1000) + ' kg';
    }

    return new Intl.NumberFormat(locale || 'es-MX', { maximumFractionDigits: 1 }).format(numericGrams) + ' g';
  }

  function weightGrams(product, variant) {
    if (!product || !variant || !Array.isArray(product.options) || !Array.isArray(variant.options)) return null;

    var weightOptionIndex = product.options.findIndex(function (optionName) {
      return String(optionName).trim().toLocaleLowerCase('es-MX') === 'peso';
    });
    if (weightOptionIndex < 0) return null;

    var match = String(variant.options[weightOptionIndex] || '').trim().match(/^(\d+(?:[.,]\d+)?)\s*(kg|g|gr)$/i);
    if (!match) return null;

    var amount = Number(match[1].replace(',', '.'));
    if (!Number.isFinite(amount) || amount <= 0) return null;

    return match[2].toLowerCase() === 'kg' ? amount * 1000 : amount;
  }

  function presentationValues(product, variant, moneyFormatter, locale) {
    if (!variant || !Number.isFinite(Number(variant.price))) return null;

    var grams = weightGrams(product, variant);
    var hasReliableWeight = grams !== null;
    var unitPrice = hasReliableWeight ? Math.round(Number(variant.price) * 1000 / grams) : null;

    return {
      weight: hasReliableWeight ? formatWeight(grams, locale) : '',
      price: moneyFormatter(Number(variant.price)),
      unitPrice: unitPrice === null ? '' : moneyFormatter(unitPrice) + ' / kg',
      hasReliableWeight: hasReliableWeight
    };
  }

  function findVariant(product, variantId) {
    if (!product || !Array.isArray(product.variants)) return null;

    for (var index = 0; index < product.variants.length; index += 1) {
      if (String(product.variants[index].id) === String(variantId)) return product.variants[index];
    }

    return null;
  }

  function updatePresentation(documentRef, product, variant, moneyFormatter, locale) {
    if (!documentRef || !product) return;

    var values = presentationValues(product, variant, moneyFormatter, locale);

    Array.prototype.forEach.call(documentRef.querySelectorAll(PRESENTATION_SELECTOR), function (container) {
      if (String(container.getAttribute('data-product-id')) !== String(product.id)) return;

      container.hidden = !values;
      if (!values) return;

      var weight = container.querySelector('[data-variant-presentation-weight]');
      var price = container.querySelector('[data-variant-presentation-price]');
      var unitPrice = container.querySelector('[data-variant-presentation-unit-price]');

      if (weight) weight.textContent = values.weight;
      if (price) price.textContent = values.price;
      if (unitPrice) {
        unitPrice.textContent = values.unitPrice;
        unitPrice.hidden = !values.hasReliableWeight;
      }
      container.classList.toggle('variant-presentation--no-weight', !values.hasReliableWeight);
    });
  }

  function parseProduct(documentRef, productId) {
    var json = documentRef.getElementById('ccProductJson-' + productId);
    if (!json) return null;

    try {
      return JSON.parse(json.textContent);
    } catch (error) {
      return null;
    }
  }

  function createMoneyFormatter(windowRef, locale) {
    var intl = windowRef && windowRef.Intl;
    var currency = windowRef && windowRef.Shopify && windowRef.Shopify.currency && windowRef.Shopify.currency.active;
    var currencyFormatter = currency && intl ? new intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      currencyDisplay: 'symbol'
    }) : null;
    var decimalFormatter = intl ? new intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) : null;

    return function (price) {
      if (currencyFormatter) return currencyFormatter.format(Number(price) / 100);
      if (decimalFormatter) return decimalFormatter.format(Number(price) / 100);
      return (Number(price) / 100).toFixed(2);
    };
  }

  function init(documentRef, windowRef) {
    if (!documentRef || !windowRef) return;

    documentRef.addEventListener('change', function (event) {
      if (event.target && event.target.matches(SELECT_SELECTOR)) {
        updateCardLinks(event.target, documentRef.baseURI);
      }
    });

    var locale = documentRef.documentElement.lang || 'es-MX';
    if (locale === 'es') locale = 'es-MX';
    var formatMoney = createMoneyFormatter(windowRef, locale);

    function updateFromSelection(container) {
      var productId = container.getAttribute('data-product-id');
      var form = container.closest('form');
      var selector = form && form.querySelector('[name="id"]');
      var product = parseProduct(documentRef, productId);
      var variant = selector && product ? findVariant(product, selector.value) : null;
      updatePresentation(documentRef, product, variant, formatMoney, locale);
    }

    Array.prototype.forEach.call(documentRef.querySelectorAll(PRESENTATION_SELECTOR), updateFromSelection);

    if (windowRef.jQuery) {
      windowRef.jQuery(windowRef).off('cc-variant-updated.variantContext').on('cc-variant-updated.variantContext', function (event, args) {
        if (args && args.product && typeof args.variant !== 'undefined') {
          updatePresentation(documentRef, args.product, args.variant, formatMoney, locale);
        }
      });
    }
  }

  return {
    createMoneyFormatter: createMoneyFormatter,
    findVariant: findVariant,
    formatWeight: formatWeight,
    init: init,
    presentationValues: presentationValues,
    updateCardLinks: updateCardLinks,
    updatePresentation: updatePresentation,
    validVariantId: validVariantId,
    variantUrl: variantUrl,
    weightGrams: weightGrams
  };
});
